import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Search } from "lucide-react";
import api from "@/lib/api";

export const MySeoLink = () => {
  const [n, setN] = useState(0);
  useEffect(() => { api.get("/api/seo/sites").then(r => setN(r.data.length)).catch(() => {}); }, []);
  if (!n) return null;
  return <Link to="/client/seo" className="mb-4 flex items-center gap-3 bg-white border border-blue-200 hover:border-blue-500 rounded-xl p-4 transition-colors" data-testid="my-seo-link"><Search className="w-5 h-5 text-blue-600" /><span className="flex-1"><b>Your SEO dashboard</b><span className="block text-sm text-slate-500">Search visibility, keywords, speed checks and reports for your website</span></span><span className="text-blue-600 font-bold">Open →</span></Link>;
};
